import { zodResolver } from '@hookform/resolvers/zod'
import { Grid } from '@mui/joy'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormValues } from '~/entities/Debt/ui/CashModal/model'
import { cashDepositSchema } from '~/shared/api'
import { Button } from '~/shared/ui/Buttons'
import {
  DatePickerInput,
  FormProvider,
  NumericInput,
  TextareaInput,
} from '~/shared/ui/Form'
import { UploadWhiteIcon } from '~/shared/ui/Icons'

type FormProps = {
  onSuccess: (formValues: FormValues) => void
  isSubmitting: boolean
}

export function Form({ onSuccess, isSubmitting }: FormProps) {
  const { t } = useTranslation()
  const form = useForm<FormValues>({
    resolver: zodResolver(cashDepositSchema),
  })

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <Grid container spacing={2.5} sx={{ padding: '4px' }}>
        <Grid xs={6}>
          <NumericInput
            name='amount'
            label='form.total'
            placeholder='form.enter total'
          />
        </Grid>
        <Grid xs={6}>
          <DatePickerInput
            placeholder='form.select date'
            label='form.date of entry'
            name='depositingDate'
          />
        </Grid>
        <Grid xs={12}>
          <TextareaInput
            label='form.comment'
            name='comment'
            placeholder='form.enter comment'
            minRows={8}
            maxRows={8}
          />
        </Grid>
      </Grid>
      <Button
        type='submit'
        loading={isSubmitting}
        fullWidth
        sx={{ marginTop: '40px' }}
        startDecorator={<UploadWhiteIcon />}
      >
        {t('button.deposit amount')}
      </Button>
    </FormProvider>
  )
}
